import actions from './actions';

const GlobalSearchModule = {
  namespaced: true,
  actions,
};

export default GlobalSearchModule;
